// Mock mode: intercepts window.fetch and seeds localStorage.
// Activated by REACT_APP_MOCK=true — never imported in production builds.
import { MOCK_TOKEN, MOCK_USER, MOCK_PROFILE, MOCK_MATCHES, MOCK_ADMIN_USERS, MOCK_ADMIN_STATS, MOCK_INGESTION_RUNS } from './mockData';
import { LS_KEYS } from './constants';

// Seed auth state so the app boots as a logged-in user
localStorage.setItem(LS_KEYS.token, MOCK_TOKEN);
localStorage.setItem(LS_KEYS.userId, MOCK_USER.user_id);
localStorage.setItem(LS_KEYS.email, MOCK_USER.email);

const DELAY = 400; // ms — simulates network latency

function respond(body, status) {
  var s = status || 200;
  return new Promise(function(resolve) {
    setTimeout(function() {
      resolve(new Response(JSON.stringify(body), {
        status: s,
        headers: { 'Content-Type': 'application/json' },
      }));
    }, DELAY);
  });
}

var originalFetch = window.fetch.bind(window);

window.fetch = function mockFetch(input, init) {
  var options = init || {};
  var url = typeof input === 'string' ? input : input.url;
  var method = (options.method || 'GET').toUpperCase();
  var path = url.replace(/^https?:\/\/[^/]+/, '');

  if (path === '/auth/login' && method === 'POST') return respond({ token: MOCK_TOKEN, user_id: MOCK_USER.user_id, email: MOCK_USER.email });
  if (path === '/auth/signup' && method === 'POST') return respond({ token: MOCK_TOKEN, user_id: MOCK_USER.user_id, email: MOCK_USER.email });
  if (path === '/auth/me') return respond({ ...MOCK_USER });
  if (path === '/profile' && method === 'GET') return respond(MOCK_PROFILE);
  if (path === '/profile' && method === 'PUT') return respond(MOCK_PROFILE);
  if (path === '/matches' && method === 'GET') return respond(MOCK_MATCHES);
  if (/^\/matches\/[^/]+\/feedback$/.test(path) && method === 'POST') return respond({ status: 'ok' });
  // Admin endpoints
  if (path === '/admin/stats' && method === 'GET') return respond(MOCK_ADMIN_STATS);
  if (path === '/admin/users' && method === 'GET') return respond(MOCK_ADMIN_USERS);
  if (path === '/admin/ingestion' && method === 'GET') return respond(MOCK_INGESTION_RUNS);
  if (/^\/admin\/ingestion/.test(path) && method === 'GET') return respond(MOCK_INGESTION_RUNS);
  if (path === '/admin/ingest' && method === 'POST') return respond({ message: 'Ingestion started (mock)' });
  if (/^\/admin\/users\/[^/]+\/matches$/.test(path) && method === 'GET') return respond(MOCK_MATCHES);
  if (/^\/admin\/users\/[^/]+\/profile$/.test(path) && method === 'GET') return respond(MOCK_PROFILE);

  if (/^\/tenders\/[^/]+$/.test(path) && method === 'GET') {
    var tenderId = path.split('/').pop();
    var match = MOCK_MATCHES.find(function(m) { return m.tender.id === tenderId; });
    return match ? respond(match.tender) : respond({ detail: 'Not found' }, 404);
  }

  return originalFetch(input, init);
};

console.info('[MockMode] API calls intercepted. Using 30 mock tenders.');
